import {
  Component,
  OnInit,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  EventEmitter,
} from "@angular/core";
import { Device as Device_new, Device } from "../devices.model_new";
import { DevicesService } from "../devices.service";
import { SortablejsOptions } from "angular-sortablejs/dist";
import { ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GeneralService } from "../../../shared/services/general.service";
import { RealTimeMessage } from "../real-time-message.model";
import { StateVariables } from "../state-variables.model";
import { DeviceType, DeviceTypesMap, STATE_VAR } from "../devices.constant";
import { SessionStateService } from "../../../core/services/session-state.service";
import { CategoriesService } from "../categories.service";
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { IotService } from "../../../core/services/iot.service";
import { SchedulingService } from "../../scheduling/scheduling.service";
import { SCHEDULE_TYPE } from "../../scheduling/scheduling.constants";
import { Observable } from "rxjs/Observable";
import { Scheduling, Schedule } from "../../scheduling/scheduling.model";
import "rxjs/add/observable/empty";
import { empty } from "rxjs/observable/empty";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-device-tab",
  templateUrl: "./device-tab.component.html",
  styleUrls: ["./device-tab.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DeviceTabComponent implements OnInit, OnDestroy {
  @Input() defaultTab: string;
  @Input() tabs: string[];
  tab: string;

  @Output()
  change: EventEmitter<boolean> = new EventEmitter<boolean>();

  initialized = false;
  loading = false;
  devicesSubscription: Subscription;
  DeviceType = DeviceType;
  devices: Device_new[];
  devicesByModuleLocalId: Map<string, Device_new>; // (Key => ModuleLocalId , Value => Device)
  devicesBySubType: Map<string, Device_new[]>; // (Key => SubType , Value => Array of Devices)
  categories = [];
  selectedCategoryId = undefined;
  options: SortablejsOptions = {};
  categoryFormControl: FormGroup;
  scheduling: Scheduling = new Scheduling();

  subTypeDevices = [];
  InactiveSubTypeDevices: Map<string, Device_new[]>;
  totalInactive: number;

  realTimeSubscription: Subscription;

  constructor(
    private devicesService: DevicesService,
    private categoriesService: CategoriesService,
    private schedulingService: SchedulingService,
    private sessionStateService: SessionStateService,
    private route: ActivatedRoute,
    private generalService: GeneralService,
    private iotService: IotService
  ) {
    this.options = {
      onUpdate: (event: any) => {
        const type: string = event.from.id;
        const newOrder: string[] = this.devicesBySubType
          .get(type)
          .map((d) => d.getModuleId());
        this.devicesService.saveDevicesOrder(`${this.tab}#${type}`, newOrder);
      },
      handle: ".my-handle",
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((values) => {
      const hasTab = values.deviceType && this.tabs.includes(values.deviceType);
      this.tab =
        values.deviceType && this.tabs.includes(values.deviceType)
          ? values.deviceType
          : this.defaultTab;
      if (this.tab !== this.defaultTab) {
        this.change.emit(hasTab);
      }
      this.getDevices();
      if (this.tab === DeviceType.CONSUMPTION) {
        this.loadCategories();
        this.generalService.langChange.subscribe(() => this.loadCategories());
      }
    });
  }

  getDevices() {
    this.totalInactive = 0;
    if (this.devicesSubscription) {
      this.devicesSubscription.unsubscribe();
    }
    this.devices = [];
    this.devicesByModuleLocalId = new Map();
    this.devicesBySubType = new Map();
    this.InactiveSubTypeDevices = new Map();
    this.loading = true;
    const deviceType = <DeviceType>this.tab;

    this.devicesSubscription = this.devicesService
      .getHouseModules(
        this.sessionStateService.getHouse().houseId,
        deviceType,
        this.selectedCategoryId
      )
      .map((resModules) => {
        const subTypes = DeviceTypesMap.map.get(deviceType).subTypes;
        resModules.forEach((d) => {
          this.devices.push(d);
          this.devicesByModuleLocalId.set(d.getModuleLocalId(), d);
          if (subTypes) {
            subTypes.map.forEach((value, key) => {
              if (
                value.groups.every((g) => d.getGroups().has(g)) &&
                value.nonGroups.every((g) => !d.getGroups().has(g))
              ) {
                this.subTypeDevices = this.devicesBySubType.get(key);
                if (this.getInactive(this.subTypeDevices).length > 0) {
                  this.InactiveSubTypeDevices.set(
                    key,
                    this.getInactive(this.subTypeDevices)
                  );
                }
                if (this.subTypeDevices) {
                  this.subTypeDevices.push(d);
                  this.devicesBySubType.set(key, this.subTypeDevices);
                } else {
                  this.subTypeDevices = [];
                  this.subTypeDevices.push(d);
                  this.devicesBySubType.set(key, this.subTypeDevices);
                }
              }
            });
          } else {
            this.devicesBySubType.set(
              this.tab.charAt(0).toLocaleUpperCase() +
                this.tab.slice(1) +
                " devices",
              this.getActive(this.devices)
            );
            if (this.getInactive(this.devices).length > 0) {
              this.InactiveSubTypeDevices.set(
                this.tab,
                this.getInactive(this.devices)
              );
            }
          }
        });
        this.devicesBySubType = this.sortDevicesDisplayOrder(
          this.devicesBySubType
        );
        this.obtainRealTimeResponses();
      })
      .flatMap(() => {
        if (
          this.tab === DeviceType.CONSUMPTION ||
          this.tab === DeviceType.CLIMATIZATION
        ) {
          return this.schedulingService
            .getScheduling(
              this.sessionStateService.getHouse().houseId,
              undefined,
              null
            )
            .map((res) => (this.scheduling = res))
            .catch((e) => of(empty));
        } else {
          return Observable.empty();
        }
      })
      .finally(() => {
        this.loading = false;
        if (
          this.tab === DeviceType.CONSUMPTION &&
          this.devicesBySubType.size === 0
        ) {
          this.devicesBySubType.set("All Devices", []);
        }
      })
      .subscribe();
  }

  private sortDevicesDisplayOrder(
    devicesToOrder: Map<string, Device_new[]>
  ): Map<string, Device_new[]> {
    const currentOrder: Map<
      string,
      string[]
    > = this.devicesService.getDevicesOrder();
    const keys: Set<string> = new Set(devicesToOrder.keys());
    keys.forEach((key) => {
      const order: string[] = currentOrder.get(`${this.tab}#${key}`);
      if (order !== undefined) {
        const value: Device_new[] = devicesToOrder.get(key);
        value.sort((v1, v2) => {
          const idx1: Number = order.indexOf(v1.getModuleId());
          const idx2: Number = order.indexOf(v2.getModuleId());
          if (idx1 > idx2 || (idx1 === -1 && idx1 !== idx2)) {
            return 1;
          } else if (idx1 < idx2) {
            return -1;
          }
          return 0;
        });
      }
    });

    return devicesToOrder;
  }

  private loadCategories(): void {
    this.categoriesService.getCategories().subscribe((res) =>
      res.subscribe(
        (resCategories) =>
          (this.categories = resCategories.map((rC) => ({
            id: rC.getId(),
            name: rC.getName(),
          })))
      )
    );
  }

  changeCategory(categoryId: string): void {
    this.selectedCategoryId = categoryId;
    this.getDevices();
  }

  getSubTypes(): string[] {
    return Array.from(this.devicesBySubType.keys());
  }

  getInactiveSubTypes(): string[] {
    return Array.from(this.InactiveSubTypeDevices.keys());
  }

  getDeviceSchedules(device: Device): Schedule[] {
    return this.scheduling.getSchedules(device);
  }

  private obtainCachedResponses(): void {
    this.iotService.responseHistory.forEach((message, moduleLocalId) => {
      this.processMessage(message);
    });
  }

  private obtainRealTimeResponses(): void {
    this.obtainCachedResponses();
    if (this.iotService.messagesObserver) {
      this.realTimeSubscription = this.iotService.messagesObserver.subscribe(
        (message) => {
          this.processMessage(message);
        }
      );
    }
  }

  private processMessage(message: any): void {
    // console.log(message);
    const device = this.devicesByModuleLocalId.get(message.moduleLocalId);
    if (device !== undefined) {
      const platformKey = message.platformKey;
      if (platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
        const statVar = device.getStateVar(platformKey);
        if (statVar) {
          statVar.value = message.value;
        }
      } else {
        device.setConnectivityState(message.value);
      }
    }
  }

  getDeviceCountByType() {
    return new Array(this.devicesBySubType.keys()).length;
  }

  getActive(devices: Device_new[]): Device_new[] {
    if (!devices) {
      return [];
    }
    return devices.filter((dev) => dev.getConnectivityState() !== "offline");
  }

  getInactive(devices: Device_new[]): Device_new[] {
    if (!devices) {
      return [];
    }
    const devicesInactive = devices.filter(
      (dev) => dev.getConnectivityState() === "offline"
    );
    this.totalInactive = devicesInactive.length;
    return devicesInactive;
  }

  getSelectedCategory() {
    return this.selectedCategoryId
      .toLowerCase()
      .replace(new RegExp("_", "g"), " ");
  }

  hasElementsInactiveByType(type: string): boolean {
    return (
      this.getInactive(this.devices).filter((d) => d.getSubType() === type)
        .length > 0
    );
  }

  ngOnDestroy(): void {
    if (this.realTimeSubscription) {
      this.realTimeSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-tab/device-tab.component.ts